<template>
  <div id="dataMapping" class="h-full">
    <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
      <el-row class="flex">
        <el-input
          size="small"
          placeholder="API名称"
          v-model.trim="keyword"
          clearable
          class="w-200px mr-10px"
        />
        <!-- <el-select
          size="small"
          v-model="updateStatus"
          clearable
          filterable
          :placeholder="$t('请选择状态')"
          class="w-200px mr-10px"
        >
          <el-option
            v-for="item in updateStatusList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          range-separator="~"
          size="small"
          :start-placeholder="$t('开始日期')"
          :end-placeholder="$t('结束日期')"
          class="mr-10px"
        >
        </el-date-picker> -->
        <el-button type="primary" @click="searchTableData()">{{ $t('search') }}</el-button>
        <el-button :disabled="!$hasAccess('create')" type="primary" @click="addMapping()">{{
          $t('create')
        }}</el-button>
        <el-button size="small" @click="importFile">{{ $t('import') }}</el-button>
        <el-button size="small" @click="exportFile" :loading="exportLoading">{{
          $t('export')
        }}</el-button>
      </el-row>
      <el-table
        border
        :data="tableData"
        v-loading="tableLoading"
        :highlight-current-row="true"
        height="calc(100% - 106px)"
        ref="multipleTable"
        class="mt-20px"
      >
        <el-table-column show-overflow-tooltip label="API名称" prop="openApiName" width="300">
        </el-table-column>
        <el-table-column label="API请求方式" show-overflow-tooltip width="120" prop="method">
        </el-table-column>
        <el-table-column label="API版本" show-overflow-tooltip prop="version" width="100">
        </el-table-column>
        <el-table-column label="映射方式" show-overflow-tooltip prop="mappingType" width="100">
        </el-table-column>
        <el-table-column label="查询内容" show-overflow-tooltip prop="content" width="300">
        </el-table-column>
        <el-table-column
          :label="$t('创建时间')"
          width="200"
          prop="creationTime"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column label="API描述" show-overflow-tooltip prop="description">
        </el-table-column>
        <el-table-column :label="$t('操作')" width="260" fixed="right">
          <template slot-scope="scope">
            <el-button
              :disabled="!$hasAccess('read')"
              size="mini"
              @click="viewMapping(scope.row.id)"
              >{{ $t('view') }}</el-button
            >
            <el-button
              size="mini"
              :disabled="!$hasAccess('update')"
              @click="editMapping(scope.row.id)"
              >{{ $t('edit') }}</el-button
            >
            <el-button
              size="mini"
              :disabled="!$hasAccess('delete')"
              @click="delMapping(scope.row.id)"
              >{{ $t('delete') }}</el-button
            >
            <el-button
              size="mini"
              :disabled="!$hasAccess('verify')"
              @click="toVerify(scope.row.openApiId)"
              >验证</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20px float-right"
        background
        @current-change="getTableData"
        @size-change="searchTableData"
        :current-page.sync="pageNo"
        :page-size.sync="pageSize"
        :page-sizes="$pageSizeAll"
        layout="total, sizes, prev, pager, next, jumper"
        :total="recordCount"
      >
      </el-pagination>
      <!-- 新增和编辑 -->
      <el-dialog
        :title="dialogTitle"
        :visible.sync="mappingDialog"
        :close-on-click-modal="false"
        width="1130px"
        v-dialogDrag
        class="addMapping"
      >
        <el-form
          label-width="130px"
          ref="queryForm"
          :rules="queryFormRules"
          :model="queryForm"
          label-position="right"
        >
          <el-row :gutter="20" class="w-full">
            <el-col :span="12">
              <el-form-item label="API地址" prop="openApiId">
                <el-select
                  size="small"
                  v-model="queryForm.openApiId"
                  class="w-full"
                  clearable
                  filterable
                  :disabled="dialogTitle === '映射详情'"
                >
                  <el-option
                    v-for="(item, index) in addressList"
                    :key="index"
                    :label="item.address"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="映射方式" prop="mappingType">
                <div class="flex">
                  <el-radio-group
                    v-model="queryForm.mappingType"
                    size="small"
                    :disabled="dialogTitle === '映射详情'"
                    @change="changeMappingType"
                  >
                    <el-radio
                      :label="item.value"
                      v-for="(item, index) in mappingTypes"
                      :key="index"
                      border
                      >{{ item.label }}</el-radio
                    >
                  </el-radio-group>
                  <el-tooltip content="查看sql示例" placement="top">
                    <i
                      size="small"
                      type="primary"
                      @click="showSqlTemplate = true"
                      class="iconfont icon-bg-circleInfo"
                    ></i>
                  </el-tooltip>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="数据库配置" prop="dbConnectionStringId">
                <el-select
                  size="small"
                  v-model="queryForm.dbConnectionStringId"
                  class="w-full"
                  clearable
                  filterable
                  :disabled="dialogTitle === '映射详情'"
                  @change="changeDBConnection"
                >
                  <el-option
                    v-for="(item, index) in databaseConfigList"
                    :key="index"
                    :label="`${item.dbTypeName}----${item.dbName}`"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="sql语句/表名" prop="parsingContent" class="w-full">
                <div class="flex">
                  <!-- 实体 -->
                  <el-select
                    v-if="queryForm.mappingType === 0"
                    size="small"
                    v-model="queryForm.parsingContent"
                    class="flex-1"
                    clearable
                    filterable
                    :disabled="dialogTitle === '映射详情'"
                  >
                    <el-option
                      v-for="(item, index) in classList"
                      :key="index"
                      :label="`${item.code} ${item.name}`"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                  <!-- SQL -->
                  <el-input
                    v-else-if="queryForm.mappingType === 1"
                    clearable
                    type="textarea"
                    v-model="queryForm.parsingContent"
                    :disabled="dialogTitle === '映射详情'"
                    class="flex-1"
                  ></el-input>
                  <!-- 数据库表 -->
                  <el-select
                    v-else-if="queryForm.mappingType === 2"
                    size="small"
                    v-model="queryForm.parsingContent"
                    class="flex-1"
                    clearable
                    filterable
                    :disabled="dialogTitle === '映射详情'"
                  >
                    <el-option
                      v-for="(item, index) in tableNameList"
                      :key="index"
                      :label="`${item.item1} ${item.item2}`"
                      :value="item.item1"
                    >
                    </el-option>
                  </el-select>
                  <!-- 指标 -->
                  <el-select
                    v-else
                    size="small"
                    v-model="queryForm.parsingContent"
                    class="flex-1"
                    clearable
                    filterable
                    :disabled="dialogTitle === '映射详情'"
                  >
                    <el-option
                      v-for="(item, index) in metricsList"
                      :key="index"
                      :label="`${item.code} ${item.name}`"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                  <el-button
                    type="primary"
                    @click="parseContent()"
                    class="w-60px ml-10px"
                    :disabled="dialogTitle === '映射详情'"
                    >解析</el-button
                  >
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-row>
          <div class="mb-10px flex items-center text-14px">
            <span class="border-l-3 border-color-primary flex-1 pl-10px text-18px">输入</span>
          </div>
          <el-table
            border
            class
            :data="requestParamMappings"
            height="150"
            :row-class-name="tableRowClassName"
          >
            <el-table-column label="参数代码" prop="sourceParamCode"> </el-table-column>
            <el-table-column label="参数名称" prop="sourceParamName"> </el-table-column>
            <el-table-column label="映射字段" prop="destParamCode">
              <template slot-scope="scope">
                <el-select
                  :disabled="dialogTitle === '映射详情'"
                  filterable
                  clearable
                  v-model="scope.row.destParamCode"
                  class="!w-full"
                >
                  <el-option
                    @click.native="changeInputCode(scope.row, item)"
                    v-for="(item, index) in requestParamSource"
                    :label="item.code"
                    :value="item.code"
                    :key="index"
                    >{{ item.code }} {{ item.name }}</el-option
                  >
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="字段名称" prop="destParamName"> </el-table-column>
            <el-table-column label="sql 参数类型" prop="sqlParamType">
              <template slot-scope="scope">
                <el-select
                  :disabled="dialogTitle === '映射详情'"
                  filterable
                  clearable
                  v-model="scope.row.sqlParamType"
                  class="!w-full"
                >
                  <el-option
                    v-for="(item, index) in inputSqlParamTypes"
                    :label="item.label"
                    :value="item.value"
                    :key="index"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
          </el-table>
          <div class="mb-10px mt-10px flex items-center text-14px">
            <span class="border-l-3 border-color-primary flex-1 pl-10px text-18px">输出</span>
          </div>
          <el-table
            border
            class
            :data="responseParamMappings"
            height="150"
            :row-class-name="tableRowClassName"
          >
            <el-table-column label="参数代码" prop="sourceParamCode"> </el-table-column>
            <el-table-column label="参数名称" prop="sourceParamName"> </el-table-column>
            <el-table-column label="映射字段" prop="destParamCode">
              <template slot-scope="scope">
                <el-select
                  :disabled="dialogTitle === '映射详情'"
                  filterable
                  clearable
                  v-model="scope.row.destParamCode"
                  class="!w-full"
                >
                  <el-option
                    @click.native="changeOutputCode(scope.row, item)"
                    v-for="(item, index) in responseParamSource"
                    :label="item.code"
                    :value="item.code"
                    :key="index"
                    >{{ item.code }} {{ item.name }}</el-option
                  >
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="字段名称" prop="destParamName"> </el-table-column>
            <el-table-column label="sql 参数类型" prop="sqlParamType">
              <template slot-scope="scope">
                <el-select
                  :disabled="dialogTitle === '映射详情'"
                  filterable
                  clearable
                  v-model="scope.row.sqlParamType"
                  class="!w-full"
                >
                  <el-option
                    v-for="(item, index) in outputSqlParamTypes"
                    :label="item.label"
                    :value="item.value"
                    :key="index"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
        <div slot="footer" class="dialog-footer tc" v-if="dialogTitle !== '映射详情'">
          <el-button type="primary" @click="queryFormSave('queryForm')" :loading="isLoading">{{
            $t('save')
          }}</el-button>
          <el-button @click="queryFormClose">{{ $t('cancel') }}</el-button>
        </div>
      </el-dialog>
      <!-- 查看sql示例 -->
      <el-dialog
        title="SQL示例"
        :visible.sync="showSqlTemplate"
        :close-on-click-modal="false"
        width="1130px"
        v-dialogDrag
      >
        <el-table border :data="sqlExampleList" height="500">
          <el-table-column label="类型" show-overflow-tooltip prop="type" width="120">
          </el-table-column>
          <el-table-column label="sql示例" prop="sql"> </el-table-column>
          <el-table-column label="注意事项" width="200" prop="notes"> </el-table-column>
        </el-table>
      </el-dialog>

      <wiz-upload-file
        v-dialogDrag
        @refreshList="searchTableData"
        :uploadFileProps="uploadFileProps"
        @exportTemplate="exportTemplate"
        @importTemplate="importTemplate"
      ></wiz-upload-file>
    </el-card>
  </div>
</template>
<script>
import FnMixins from '@/assets/js/fnMixins'
import {
  DbConnectionStringApi,
  OpenApiDataMappingApi,
  OpenApiApi,
} from '@wiz-api/open-api-management'

import dayjs from 'dayjs'

const dbConnectionStringApi = new DbConnectionStringApi()
const openApiDataMappingApi = new OpenApiDataMappingApi()
const openApiApi = new OpenApiApi()
export default {
  name: 'dataMapping',
  mixins: [FnMixins],
  data() {
    return {
      uploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 1, // 目前状态页面1为下载模板 2为上传模板 3为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xls', 'xlsx'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
      },
      dialogTitle: '映射新增',
      pageNo: 1,
      pageSize: 15,
      recordCount: 0,
      tableLoading: false,
      tableData: [],
      queryForm: {
        openApiId: '',
        mappingType: '',
        parsingContent: '',
        dbConnectionStringId: null,
      },
      keyword: '',
      dateRange: [],
      updateStatusList: [
        { id: 0, name: '失败' },
        { id: 1, name: '成功' },
      ],
      updateStatus: '',
      mappingDialog: false,
      queryFormRules: {
        openApiId: [{ required: true, message: '请选择api地址', trigger: 'blur' }],
        mappingType: [{ required: true, message: '请选择映射方式', trigger: 'blur' }],
        parsingContent: [{ required: true, message: '请输入sql语句/表名', trigger: 'change' }],
        dbConnectionStringId: [{ required: true, message: '请选择数据库配置', trigger: 'blur' }],
      },
      isLoading: false,
      mappingTypes: [],
      apiAddressList: [],
      requestParamMappings: [],
      responseParamMappings: [],
      requestParamSource: [],
      responseParamSource: [],
      detailId: '',
      concurrencyStamp: '',
      inputSqlParamTypes: [],
      outputSqlParamTypes: [],
      tableNameList: [],
      sqlExampleList: [],
      showSqlTemplate: false,
      addApiAddressList: [],
      addressList: [],
      databaseConfigList: [],
      exportLoading: false,
      classList: [], // 实体列表
      metricsList: [], // 指标列表
    }
  },
  async created() {
    await this.getMappingTypes() // 获取映射方式
    await this.getApiAddress() // 获取api地址
    this.searchTableData() // 获取表格数据
    this.getSqlParamTypes(1) // 获取sql参数类型(输入)
    this.getSqlParamTypes(2) // 获取sql参数类型(输出)
    this.getSqlExample() // 获取sql示例
  },
  methods: {
    // 导入
    importFile() {
      this.uploadFileProps.visible = true
      this.uploadFileProps.active = 0
    },
    // 下载导入模板
    async exportTemplate() {
      const [err, res] = await openApiDataMappingApi.downloadTemplate()
      // 返回的是文件流
      if (!err) {
        this.downLoadBlob({
          name: '数据映射导入模板.xlsx',
          data: res,
        })
      }
    },
    // 上传已填写的模板
    async importTemplate(file) {
      this.uploadFileProps.btnLoading = true
      const formData = new FormData()
      _.forIn({ file }, (value, key) => {
        formData.append('file', value)
      })
      const [err, res] = await openApiDataMappingApi.callImport({
        file: formData.get('file'),
      })
      if (!err) {
        this.uploadFileProps.active = 2
        this.downLoadBlob({
          name: '数据映射导入明细.xlsx',
          data: res,
        })
        this.searchTableData()
      }
      this.uploadFileProps.btnLoading = false
    },
    // 导出
    async exportFile() {
      this.exportLoading = true
      const [err, res] = await openApiDataMappingApi.callExport({
        body: {
          openApiName: this.keyword,
        },
      })
      this.exportLoading = false
      // 返回的是文件流
      if (!err) {
        this.downLoadBlob({
          name: '数据映射导出结果.xlsx',
          data: res,
        })
      }
    },
    // 修改数据库配置
    changeDBConnection(val) {
      if (val) {
        this.getTableName()
      }
      if (this.queryForm.mappingType !== 1) {
        this.queryForm.parsingContent = ''
      }
    },
    // 获取数据库配置列表
    async getDatabaseConfigure() {
      const params = {
        dbName: '',
        dbType: '',
        sorting: '',
        skipCount: 1,
        maxResultCount: 999,
      }
      const [err, res] = await dbConnectionStringApi.getList(params)
      if (!err) {
        this.databaseConfigList = res.items
      }
    },
    // 修改映射方式
    changeMappingType(mappingType) {
      if (mappingType === 0) {
        this.getStdClassList()
      } else if (mappingType === 4) {
        this.getMetricsList()
      }
      this.queryForm.parsingContent = ''
      this.requestParamSource = [] // 输入数据源
      this.responseParamSource = [] // 输出数据源
    },
    // 查询实体列表（已审批状态）
    async getStdClassList() {
      const [err, res] = await openApiDataMappingApi.getStdClassList({ keyword: '' })
      if (!err) {
        this.classList = res
      }
    },
    // 查询指标列表(已发布状态)
    async getMetricsList() {
      const [err, res] = await openApiDataMappingApi.getMetricsList({ keyword: '' })
      if (!err) {
        this.metricsList = res
      }
    },
    // 查询数据库表
    async getTableName() {
      const params = {
        dbConnectionStringId: this.queryForm.dbConnectionStringId,
      }
      const [err, res] = await openApiDataMappingApi.getTables(params)
      if (!err) {
        //  "item1":"表名","item2":"表注释"
        this.tableNameList = res
      }
    },
    // api验证
    toVerify(id) {
      this.$router.push(`./api-release-create?id=${id}&type=verify`)
    },
    // 获取sql示例
    async getSqlExample() {
      const [err, res] = await openApiDataMappingApi.getSqlExamples()
      if (!err) {
        this.sqlExampleList = res
      }
    },
    // 修改输入映射字段
    changeInputCode(row, item) {
      this.requestParamMappings[row.index].destParamName = item.name ? item.name.trim() : null
      this.requestParamMappings[row.index].destParamCode = item.code.trim()
    },
    // 修改输出映射字段
    changeOutputCode(row, item) {
      this.responseParamMappings[row.index].destParamName = item.name ? item.name.trim() : null
      this.responseParamMappings[row.index].destParamCode = item.code.trim()
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex
    },
    // 解析
    parseContent(type) {
      this.$refs.queryForm.validate(async (valid) => {
        if (valid) {
          const params = {
            openApiId: this.queryForm.openApiId,
            mappingType: this.queryForm.mappingType,
            parsingContent: this.queryForm.parsingContent,
            dbConnectionStringId: _.includes([1, 2], this.queryForm.mappingType)
              ? this.queryForm.dbConnectionStringId
              : null,
          }
          const [err, res] = await openApiDataMappingApi.parsingParams(params)
          if (!err) {
            if (type === 'edit') {
              this.requestParamSource = res.requestParamSource ? res.requestParamSource : [] // 输入数据源
              this.responseParamSource = res.responseParamSource ? res.responseParamSource : [] // 输出数据源
              return
            }
            this.requestParamMappings = res.requestParamMappings ? res.requestParamMappings : [] // 输入
            this.responseParamMappings = res.responseParamMappings ? res.responseParamMappings : [] // 输出
            this.requestParamSource = res.requestParamSource ? res.requestParamSource : [] // 输入数据源
            this.responseParamSource = res.responseParamSource ? res.responseParamSource : [] // 输出数据源
            // 输入的sql参数类型,接口返回有值就拿接口返回的，否则默认为2
            if (this.requestParamMappings.length > 0) {
              this.requestParamMappings = _.map(this.requestParamMappings, (item) => {
                item.sqlParamType = item.sqlParamType ? item.sqlParamType : 2
                return item
              })
            }
            // 映射字段与参数代码相同时，自动匹配填充(不区分大小写)
            _.map(this.requestParamMappings, (item) => {
              _.map(this.requestParamSource, (sItem) => {
                if (item.sourceParamCode.toLowerCase() === sItem.code.toLowerCase()) {
                  item.destParamCode = sItem.code
                  item.destParamName = sItem.name
                }
              })
              return item
            })
            _.map(this.responseParamMappings, (item) => {
              _.map(this.responseParamSource, (sItem) => {
                if (item.sourceParamCode.toLowerCase() === sItem.code.toLowerCase()) {
                  item.destParamCode = sItem.code
                  item.destParamName = sItem.name
                }
              })
              return item
            })
          }
        }
      })
    },
    // 获取映射方式
    async getMappingTypes() {
      const [err, res] = await openApiDataMappingApi.getMappingTypes()
      if (!err) {
        this.mappingTypes = _.map(res, (item) => {
          return {
            label: item.item2,
            value: item.item1,
          }
        })
      }
    },
    // 获取新增映射的api地址（映射后的api会去掉）
    async getAddApiAddress() {
      const reqData = {
        skipCount: 1,
        maxResultCount: 999,
        sorting: '',
        keywords: '',
        type: '',
        status: '',
        isEnabled: 1, // 1 查启用的， -1 查所有，0 查弃用的吧
      }
      const [err, res] = await openApiApi.getEmptyDataMappingsOpenApi(reqData)
      if (!err) {
        this.addApiAddressList = res.items
        this.addressList = this.addApiAddressList
      }
    },
    // 获取api地址
    async getApiAddress() {
      const reqData = {
        skipCount: 1,
        maxResultCount: 999,
        sorting: '',
        keywords: '',
        type: '',
        status: '',
        isEnabled: 1, // 1 查启用的， -1 查所有，0 查弃用的吧
      }
      const [err, res] = await openApiApi.getList(reqData)
      if (!err) {
        this.apiAddressList = res.items
      }
    },
    // 获取sql参数类型
    async getSqlParamTypes(type) {
      const [err, res] = await openApiDataMappingApi.getSqlParamTypes({ paramType: type })
      if (!err) {
        if (type === 1) {
          // 输入
          this.inputSqlParamTypes = _.map(res, (item) => {
            return {
              label: item.item2,
              value: item.item1,
            }
          })
        } else if (type === 2) {
          // 输出
          this.outputSqlParamTypes = _.map(res, (item) => {
            return {
              label: item.item2,
              value: item.item1,
            }
          })
        }
      }
    },
    // 映射新增
    async addMapping() {
      this.detailId = ''
      this.mappingDialog = true
      this.dialogTitle = '映射新增'
      this.queryForm = this.$options.data().queryForm
      this.requestParamMappings = [] // 输入
      this.responseParamMappings = [] // 输出
      this.requestParamSource = [] // 输入数据源
      this.responseParamSource = [] // 输出数据源
      this.queryForm.mappingType = 1 // 新增默认选中sql
      await this.getAddApiAddress() // 获取新增api地址
      await this.getDatabaseConfigure()
    },
    searchTableData() {
      this.pageNo = 1
      this.getTableData()
    },
    // 搜索表格
    async getTableData() {
      this.tableLoading = true
      const parameter = {
        openApiName: this.keyword,
        sorting: '',
        skipCount: this.pageNo,
        maxResultCount: this.pageSize,
        // update_status: this.updateStatus,
        // startdate:
        //   this.dateRange && this.dateRange.length
        //     ? dayjs(this.dateRange[0]).format('YYYY-MM-DD')
        //     : '',
        // enddate:
        //   this.dateRange && this.dateRange.length
        //     ? dayjs(this.dateRange[1]).format('YYYY-MM-DD')
        //     : '',
      }
      const [err, res] = await openApiDataMappingApi.getPagedResult(parameter)
      if (!err) {
        this.tableData = _.map(res.items, (item) => {
          if (item.creationTime) {
            item.creationTime = dayjs(new Date(item.creationTime)).format('YYYY-MM-DD HH:mm:ss')
          }
          return item
        })
        this.recordCount = res.totalCount
        this.$nextTick(() => {
          this.$refs.multipleTable.doLayout()
        })
      }
      this.tableLoading = false
    },
    // 删除
    delMapping(id) {
      this.$confirm('是否确认删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [err, res] = await openApiDataMappingApi.deleteMany({ ids: [id] })
          if (!err) {
            this.$message.success('删除成功')
            if (this.tableData.length === 1 && this.pageNo > 1) {
              this.pageNo -= 1
            }
            this.getTableData()
          }
        })
        .catch(() => {})
    },
    // 映射详情
    async viewMapping(id) {
      this.dialogTitle = '映射详情'
      this.mappingDialog = true
      await this.getDatabaseConfigure()
      this.getDetail(id)
    },
    // 获取详情
    async getDetail(id) {
      const [err, res] = await openApiDataMappingApi.get(id)
      if (!err) {
        this.concurrencyStamp = res.concurrencyStamp
        this.detailId = res.id
        this.queryForm.openApiId = res.openApiId
        this.queryForm.mappingType = res.mappingType
        this.queryForm.parsingContent = res.mappingType === 1 ? res.sql : res.tableName
        this.queryForm.dbConnectionStringId = res.dbConnectionStringId
        this.requestParamMappings = _.filter(res.openApiParamMappings, (item) => {
          return item.paramType === 1
        })
        this.responseParamMappings = _.filter(res.openApiParamMappings, (item) => {
          return item.paramType === 2
        })
        const currentAddress = _.find(this.apiAddressList, ['id', res.openApiId])
        if (currentAddress) {
          this.addressList = this.addApiAddressList.concat([currentAddress])
        }
        if (this.queryForm.mappingType === 0) {
          this.getStdClassList()
        } else if (this.queryForm.mappingType === 2) {
          this.getTableName()
        } else if (this.queryForm.mappingType === 4) {
          this.getMetricsList()
        }
      }
    },
    // 映射编辑
    async editMapping(id) {
      this.dialogTitle = '映射编辑'
      this.mappingDialog = true
      await this.getDatabaseConfigure()
      await this.getDetail(id)
      this.parseContent('edit')
    },
    // 保存
    queryFormSave() {
      const params = {
        flag: 0,
        openApiId: this.queryForm.openApiId,
        mappingType: this.queryForm.mappingType,
        tableName: this.queryForm.mappingType !== 1 ? this.queryForm.parsingContent : null,
        sql: this.queryForm.mappingType === 1 ? this.queryForm.parsingContent : null,
        dbConnectionStringId: this.queryForm.dbConnectionStringId,
        openApiParamMappings: [],
      }
      params.openApiParamMappings = this.requestParamMappings.concat(this.responseParamMappings)
      params.openApiParamMappings = _.map(params.openApiParamMappings, (item, index) => {
        item.seqNo = index
        return item
      })
      this.$refs.queryForm.validate(async (valid) => {
        if (valid) {
          // 映射方式为自定义sql的时候，在保存接口之前校验sql语法
          let flag = true
          if (this.queryForm.mappingType === 1) {
            flag = await this.verifySqlSyntax()
          }
          if (!flag) {
            // this.$message.warning('sql语法错误，请检查sql')
            return
          }
          this.isLoading = true
          if (this.detailId) {
            params.concurrencyStamp = this.concurrencyStamp
            const [err, res] = await openApiDataMappingApi.update(this.detailId, { body: params })
            if (!err) {
              this.$message.success('修改成功')
              this.isLoading = false
              this.mappingDialog = false
              this.getTableData()
            }
          } else {
            const [err, res] = await openApiDataMappingApi.create({ body: params })
            if (!err) {
              this.$message.success('新增成功')
              this.isLoading = false
              this.mappingDialog = false
              this.getTableData()
            }
          }
          this.isLoading = false
        }
      })
    },
    // 取消
    queryFormClose() {
      this.mappingDialog = false
    },
    // 校验sql语法
    async verifySqlSyntax() {
      const [err, res] = await openApiDataMappingApi.verifySqlSyntax({
        body: {
          openApiId: this.queryForm.openApiId,
          dbConnectionStringId: this.queryForm.dbConnectionStringId,
          sql: this.queryForm.parsingContent,
          openApiParamMappings: this.requestParamMappings.concat(this.responseParamMappings),
        },
      })
      if (!err) {
        return true
      }
      return false
    },
  },
}
</script>
<style lang="scss">

.el-tooltip__popper {
  max-width: 30%;
}

</style>
<style lang="scss" scoped>

/deep/.el-radio {
  margin-right: 5px !important;
}
.addMapping {
  /deep/.el-dialog {
    margin-top: 5vh !important;
  }
}

</style>
